module.exports = __webpack_public_path__ + "static/media/curve.2f166f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/curve.png
// module id = 644
// module chunks = 0